import { useAuth } from "../auth/AuthProvider";

/** Presentation-decoupled data hooks — all business logic lives in the backend. */
export function useApi() {
  const { apiGet, apiPost } = useAuth();
  return {
    // Catalog
    catalog: (q = "", categoryId = "") => apiGet(`/api/catalog${q || categoryId ? `?${new URLSearchParams({ ...(q && { q }), ...(categoryId && { category_id: categoryId }) })}` : ""}`),
    categories: () => apiGet("/api/categories"),
    productDocs: (productId) => apiGet(`/api/products/${productId}/documents`),
    // Delivery points
    myDeliveryPoints: () => apiGet("/api/delivery-points"),
    // Pricing
    previewCart: (body) => apiPost("/api/pricing/preview", body),
    // Orders
    createOrder: (body) => apiPost("/api/orders", body),
    myOrders: () => apiGet("/api/orders"),
    orderDetail: (id) => apiGet(`/api/orders/${id}`),
    orderTracking: (id) => apiGet(`/api/orders/${id}/tracking`),
    shipmentsByOrder: (id) => apiGet(`/api/shipments/by-order/${id}`),
    reorder: (body) => apiPost("/api/orders/reorder", body),
    // Templates
    templates: () => apiGet("/api/order-templates"),
    createTemplate: (body) => apiPost("/api/order-templates", body),
    previewTemplate: (id) => apiGet(`/api/order-templates/${id}/preview`),
    // PFA
    myPfa: () => apiGet("/api/pfa/targets"),
    // Agent
    myCustomer: () => apiGet("/api/customers"),
  };
}
